import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

export default new Vuex.Store({

  state: {
    // count: 0,
    // user: {
    //   // id: '',
    //   // email: '',
    //   // invited_code: '',
    //   // test_fin_time: '',
    //   // register_time: '',
    // },
  },
  mutations: {
    // increment(state,n) {
    //   state.count =n;
    // }
    // increment(state,payload){
    //   state.user=payload;
    // }
  },



  actions: {
  },
  modules: {
  }
})


